module.exports = __webpack_public_path__ + "static/media/tree-christmas.2086f727.svg";